import NonLoginShoppingCartButton from '~/components/NonLogin/NonLoginShoppingCartButton';
import { useCurrentUser } from '~/domains/auth/queries';
import ShoppingCartButton from '~/domains/cart/ShoppingCartButton';
import ProductPrice from '~/domains/products/components/ProductPrice';
import ProductSalesTargetBadge from '~/domains/products/components/ProductSalesTargetBadge';
import ProductImage from '~/domains/products/ProductImage';
import { useTrackProductEventProps } from '~/hooks/event';
import { useLinkComponent } from '~/hooks/mobileApp';
import type { OAISchema } from '~/types/openapi';

type Props = {
  inverse?: boolean;
  onClick?: (item: OAISchema['MarketSelectProductResponseV2']) => void;
  onCartClick?: (item: OAISchema['MarketSelectProductResponseV2']) => void; // TODO - 앰플리튜드 이벤트 한번 싹 정리할 떄, 제거 함.
  eventOption?: Record<string, unknown>;
  plusMembershipFullBadge?: boolean;
  reverseCouponDiscountedPrice?: boolean;
} & OAISchema['MarketSelectProductResponseV2'];

const FrequentlyOrderedProductCard = ({
  onClick,
  onCartClick,
  eventOption,
  plusMembershipFullBadge = false,
  reverseCouponDiscountedPrice = false,
  ...data
}: Props) => {
  const { isLoggedIn } = useCurrentUser();
  const LinkComponent = useLinkComponent();
  const [props, { trackAddCart }] = useTrackProductEventProps(
    data,
    eventOption,
  );

  const {
    offerId,
    vendorId,
    mainImages,
    productName,
    isOutOfStock,
    status,
    inverse,
    mallName,
    salesTargets,
    orderCount,
  } = data;

  return (
    <LinkComponent href={`/vendors/${vendorId}/products/${offerId!}`}>
      <div role="presentation" {...props} onClick={props.onClick}>
        <ProductImage
          width={100}
          height={100}
          sizes="45vw"
          layout="responsive"
          src={mainImages![0]}
          alt={productName}
          isOutOfStock={isOutOfStock}
          status={status}
          inverse={inverse}
          rightBottom={
            isLoggedIn ? (
              <ShoppingCartButton
                className="mb-6 mr-8"
                onClick={() => {
                  onClick?.(data);
                  trackAddCart?.();
                  onCartClick?.(data);
                }}
                item={data}
              />
            ) : (
              <NonLoginShoppingCartButton />
            )
          }
        />
        {orderCount && (
          <div className="-mt-2 text-primary-regular typo-footnote300-semibold">
            {orderCount}회 이상 구매한 상품
          </div>
        )}
        <ProductSalesTargetBadge
          salesTargets={salesTargets}
          className="mt-4"
          full={plusMembershipFullBadge}
        />
        <div className="mt-4 text-hint typo-footnote300-regular">
          {mallName}
        </div>
        <div
          className="my-4 line-clamp-2 whitespace-pre-line leading-[18px] text-normal"
          style={{ fontSize: '14px' }}
        >
          {productName}
        </div>
        <ProductPrice {...data} reverse={reverseCouponDiscountedPrice} />
      </div>
    </LinkComponent>
  );
};

export default FrequentlyOrderedProductCard;
